define
('pag_section',[
	'jquery'
	,
	'bootstrap-toolkit'
	,
	'select2'
	,
	'hbs'
	,
	'owl_slider'
	,
	'owl_slider_navigation'
	,
	'owl_slider_autoplay'
	,
	'busy'
],
function
(
	jquery
	,
	bootstrapToolkit
	,
	Select2
	,
	hbs
	,
	owl_slider
	,
	owl_slider_navigation
	,
	owl_slider_autoplay
	,
	Busy
) {


	//--
	if(typeof(window.busy) === 'undefined'){
		window.busy = Busy;
	}


	// var tmpl 				= handlebars.compile($("#item_list-template").html());

	var date_yy 		= $('[name=date_yy][type!="hidden"]');
	var date_mm        	= $('[name=date_mm][type!="hidden"]');
	// var date_curr_yy        = $('[name=date_curr_yy][type!="hidden"]');

	//-- Path
	var path = '';
	//-- Path
	var data_id = '';

	//-- Path
	var data_in = '';

	//-- Page Current
	var page = '';
	//-- Page Next
	var page_next = '';
	//-- Page Count
	var items_count = '';

	//-- Page Each
	var items_per_page = '';

	//-- Data Count
	var items_count = '';
	//-- Data Pivot
	var items_pivot = '';


	// //-- Year
	// var file_year = '';
	// //-- Month
	// var file_month = '';

	//-- Filter Topic
	var topic = '';
	//-- Filter section
	var section = '';

	// //-- Filter Issue
	// var file_fi = '';
	// //-- Filter Section
	// var file_fs = '';

	//-- Wrap IIFE around your code
	(function($, document, window, viewport){

		// console.log('viewport_current: '+viewport.current());

		// //--
		// var resp = function(view){

		// 	console.log('viewport_current: '+view.current());
		// 	console.info('view: ', view);

		// 	//--
		// 	if(view) {
		// 		// console.log('viewport_current: '+view.current());

		// 		//--
		// 		// console.info('view: ', view);
		// 	}

		// 	//-- Menú, Tick
		// 	if(view && view.is('>sm')) {
		// 		//--
		// 		// console.info('view > sm');


		// 		//--
		// 		// console.info('Activate: Meny Side Stuk');
		// 		//--
		// 		posa 			= document.getElementById('pos_a');
		// 		area_posa 		= document.getElementById('pos_a_area');
		// 		area_posb 		= document.getElementById('pos_b_area');
		// 		//--
		// 		if(posa.offsetHeight > area_posb.offsetHeight){
		// 			area_posa.style.height = posa.offsetHeight+'px';
		// 		}
		// 		else{
		// 			area_posa.style.height = area_posb.offsetHeight+'px';
		// 		}
		// 		console.log('posa.offsetHeight: ', posa.offsetHeight);
		// 		console.log('area_posa: ', area_posa.offsetHeight);
		// 		console.log('area_posb: ', area_posb.offsetHeight);

		// 		//-- Create waypoints
		// 		require(['Waypoints', 'WaypointsSticky'], function (Waypoints, WaypointsSticky){

		// 			if(window.tick_side != null && window.tick_side != false ){
		// 				//--
		// 				Waypoint.refreshAll();
		// 			}
		// 		});
		// 	}
		// }




		$(document).ready(function() {


			$('#slip_pict_area .owl-carousel').on('click', '.owl-item .item > a', function(item){
				item.preventDefault();
				// console.log($(this));


				//-- Sort
				var sort = $(this).attr('data-sort');
				//-- Mtag
				var path_mtag = $(this).attr('data-path_mtag');
				//-- Mtag Update More
				$('#col_rows #more').attr('data-path_mtag', path_mtag);


				console.log('sort', sort);
				console.log('path_mtag: ', path_mtag);


				//--
				$("#slip_pict_area .owl-carousel").data("owl.carousel").to(sort);
				//--
				// $('#slip_pict_area .owl-carousel .owl-item .item[data-slug="'+curr+'"]')
			});


		});
	})(jQuery, document, window, ResponsiveBootstrapToolkit);


	//--
	var Pag = (function() {
		var fun            = {};
		var popups         = {};
		fun.moduleProperty = 1;
		// $.bridget( 'isotope', Isotope );

		// console.log(bootstrapToolkit);

		fun.init    = function () {


			// //--
			// if(date_curr_yy.length > 0)
			// {
			// 	//--
			// 	date_curr_yy
			// 	.select2({
			// 			data: Array()
			// 		, allowClear: true
			// 		, theme: "bootstrap"
			// 		// , theme: "default"
			// 		, width: 'style'
			// 		, dropdownCssClass : 'full-width'
			// 		, placeholder: date_curr_yy.attr('data-placeholder')
			// 		, minimumResultsForSearch: Infinity
			// 	});
			// }

			// //--
			// if(date_yy.length > 0)
			// {
			// 	date_yy.select2({
			// 		allowClear: true
			// 		,
			// 		theme: "bootstrap"
			// 		,
			// 		// theme: "default"
			// 		// ,
			// 		width: 'style'
			// 		,
			// 		dropdownCssClass : 'full-width'
			// 		,
			// 		placeholder: date_yy.attr('data-placeholder')
			// 		,
			// 		minimumResultsForSearch: Infinity
			// 		,
			// 		formatNoResults: function () {
			// 			return "No se han encontrado registros para el criterio seleccionado.";
			// 		}
			// 		,
			// 		formatAjaxError: function () {
			// 			return "Ha ocurrido un inconveniente para extraer los datos. Intenta en un momento.";
			// 		}
			// 	})
			// 	.change(function() {
			// 		var sel    = date_yy.find('option:selected').val();
			// 		var get    = window.BB.base_url + '/date_yy/' + sel;
			// 		// console.log('URL: '+get);=±±±±====+++

			// 		//--
			// 		var year_curr 				= '';
			// 		var year_data 				= '';

			// 		//--
			// 		var year_data 				= date_yy.find('option:selected').val();

			// 		//--
			// 		var sel_published_after 	= date_yy.find('option:selected').attr('data-published_after');
			// 		var sel_published_before 	= date_yy.find('option:selected').attr('data-published_before');

			// 		//--
			// 		var item;
			// 		var data_in;
			// 		var data_year;
			// 		var data_month;
			// 		item = $('#col_rows #more');
			// 		data_in 	= item.attr('data-in');
			// 		// data_year 	= item.attr('data-year');
			// 		data_year 	= sel;
			// 		data_month 	= item.attr('data-month');

			// 		//--
			// 		$('#list_data').empty();

			// 		//-- Filter Year
			// 		item.attr('data-year', data_year);

			// 		//-- Filter Year
			// 		item.attr('data-month', data_month);

			// 		//-- Page Number
			// 		item.attr('data-in', '1');
			// 		//-- Page Number
			// 		item.attr('data-page', 0);


			// 		//--
			// 		if(sel_published_after != ''){
			// 			//-- Filter Year
			// 			item.attr('data-published_after', sel_published_after);
			// 		}
			// 		else
			// 		{
			// 			//-- Filter Year
			// 			item.attr('data-published_after', '');
			// 		}


			// 		//--
			// 		if(sel_published_before != ''){
			// 			//-- Filter Year
			// 			item.attr('data-published_before', sel_published_before);
			// 		}
			// 		else
			// 		{
			// 			//-- Filter Year
			// 			item.attr('data-published_before', '');
			// 		}


			// 		//--
			// 		if(sel && sel!=''){
			// 			//--
			// 			if(date_mm.length > 0)
			// 			{
			// 				// //-- 
			// 				// date_mm
			// 				// .empty()
			// 				// .select2({
			// 				// 	  data: Array()
			// 				// 	, allowClear: true
			// 				// 	, theme: "bootstrap"
			// 				// 	// , theme: "default" 
			// 				// 	, width: 'style'
			// 				// 	, dropdownCssClass : 'full-width'
			// 				// 	, placeholder: date_mm.attr('data-placeholder')
			// 				// 	, minimumResultsForSearch: Infinity
			// 				// });
			// 				if(date_mm.data('select2') != null ){
			// 					date_mm.select2('enable', true);
			// 				}
			// 			}
			// 		}
			// 		else
			// 		{
			// 			//--
			// 			if(date_mm.length > 0)
			// 			{
			// 				// //-- 
			// 				// date_mm
			// 				// .empty()
			// 				// .select2({
			// 				// 	  data: Array()
			// 				// 	, allowClear: true
			// 				// 	, theme: "bootstrap"
			// 				// 	// , theme: "default" 
			// 				// 	, width: 'style'
			// 				// 	, dropdownCssClass : 'full-width'
			// 				// 	, placeholder: date_mm.attr('data-placeholder')
			// 				// 	, minimumResultsForSearch: Infinity
			// 				// });
			// 				if(date_mm.data('select2') != null ){
			// 					date_mm.select2('enable', false);
			// 				}
			// 			}
			// 		}

			// 		//--
			// 		$('#col_rows #more').click();


			// 	})
			// 	.select2('enable', true);
			// }

			// //--
			// if(date_mm.length > 0)
			// {
			// 	date_mm.select2({
			// 		  allowClear: true
			// 		, theme: "bootstrap"
			// 		// , theme: "default"
			// 		, width: 'style'
			// 		, dropdownCssClass : 'full-width'
			// 		, placeholder: date_mm.attr('data-placeholder')
			// 		, minimumResultsForSearch: Infinity
			// 		, formatNoResults: function () {
			// 			return "No se han encontrado registros para el criterio seleccionado.";
			// 		}
			// 		, formatAjaxError: function () {
			// 			return "Ha ocurrido un inconveniente para extraer los datos. Intenta en un momento.";
			// 		}
			// 	})
			// 	.change(function() {
			// 		//--
			// 		var year_curr 				= '';
			// 		var year_data 				= '';

			// 		//--
			// 		var sel 					= date_mm.find('option:selected').val();
			// 		var get    					= window.BB.base_url + '/date_yy/' + sel;

			// 		//--
			// 		var sel_published_after 	= date_mm.find('option:selected').attr('data-published_after');
			// 		var sel_published_before 	= date_mm.find('option:selected').attr('data-published_before');


			// 		//--
			// 		year_curr = new Date();
			// 		year_curr = year_curr.getFullYear();

			// 		//--
			// 		year_data = date_yy.find('option:selected').val();


			// 		//--
			// 		var item;
			// 		var data_in;
			// 		var data_year;
			// 		var data_month;
			// 		item = $('#col_rows #more');
			// 		data_in 	= item.attr('data-in');
			// 		data_year 	= item.attr('data-year');
			// 		// data_month 	= item.attr('data-month');
			// 		data_month 	= sel;

			// 		//--
			// 		$('#list_data').empty();

			// 		//-- Filter Year
			// 		item.attr('data-year', data_year);

			// 		//-- Filter Year
			// 		item.attr('data-month', data_month);

			// 		//-- Page Number
			// 		item.attr('data-in', '1');
			// 		//-- Page Number
			// 		item.attr('data-page', 0);

			// 		//--
			// 		if(sel_published_after && sel_published_after != ''){
			// 			sel_published_after = sel_published_after.replace(year_curr, year_data);
			// 		}

			// 		//--
			// 		if(sel_published_before && sel_published_before != ''){
			// 			sel_published_before = sel_published_before.replace(year_curr, year_data);
			// 		}

			// 		//--
			// 		if(sel_published_after && sel_published_after != ''){
			// 			//-- Filter Year
			// 			item.attr('data-published_after', sel_published_after);
			// 		}
			// 		else
			// 		{
			// 			item.attr('data-published_after', '');
			// 		}
			// 		//--
			// 		if(sel_published_before && sel_published_before != ''){
			// 			//-- Filter Year
			// 			item.attr('data-published_before', sel_published_before);
			// 		}
			// 		else
			// 		{
			// 			item.attr('data-published_before', '');
			// 		}

			// 		//--
			// 		$('#col_rows #more').click();


			// 		//-- 
			// 		if(!sel) return false;


			// 	})
			// 	.select2('enable', false);
			// }


			var posi = $('#list_data').attr('data-posx');


			//--
			// console.log(ResponsiveBootstrapToolkit);
			// console.log(bootstrapToolkit);

			// function center(number){
			// 	var owls_a = $("#slip_pict_area .owl-carousel");
			// 	var owls_b = $("#slip_ctrl_area .owl-carousel");
			// 	var owls_b_visible = owls_b.data("owlCarousel").owl.visibleItems;
			// 	var num = number;
			// 	var found = false;
			// 	for(var i in owls_b_visible){
			// 		if(num === owls_b_visible[i]){
			// 			var found = true;
			// 		}
			// 	}

			// 	if(found===false){
			// 		if(num>owls_b_visible[owls_b_visible.length-1]){
			// 			owls_b.trigger("owl.goTo", num - owls_b_visible.length+2)
			// 		}
			// 		else
			// 		{
			// 			if(num - 1 === -1){
			// 				num = 0;
			// 			}
			// 			owls_b.trigger("owl.goTo", num);
			// 		}
			// 	}
			// 	else
			// 		if(num === owls_b_visible[owls_b_visible.length-1]){
			// 			owls_b.trigger("owl.goTo", owls_b_visible[1])
			// 		}
			// 		else
			// 			if(num === owls_b_visible[0]){
			// 				owls_b.trigger("owl.goTo", num-1)
			// 			}
			// }

			//--
			if($("#slip_pict_area .owl-carousel").length > 0){

				var owls_a = $("#slip_pict_area .owl-carousel");
				if(0 < owls_a.length){
					var item_amount = parseInt( owls_a.find('.item').length );
					var true_false  = 0;

					//--
					if ( item_amount <=1 ) {
						true_false = false;
					}
					else
					{
						true_false = true;
					}

					//--
					owls_a.owlCarousel({
						onInitialized: function(event) {

							// //--
							// var fire;

							// //--
							// fire.attr('data-topic', posi);

						}
						,
						onChanged: function(event) {
							// console.log('owls_a onChange');
							// el.find(".owl-item").eq(0).addClass("synced");
							//-- Provided by the core
							var element   = event.target;         // DOM element, in this example .owl-carousel
							var name      = event.type;           // Name of the event, in this example dragged
							var namespace = event.namespace;      // Namespace of the event, in this example owl.carousel
							var items     = event.item.count;     // Number of items
							var item      = event.item.index;     // Position of the current item
							//-- Provided by the navigation plugin
							var pages     = event.page.count;     // Number of pages
							var page      = event.page.index;     // Position of the current page
							var size      = event.page.size;      // Number of items per page

							// console.info('owls_a');

							if($("#slip_pict_area .owl-carousel").data("owl.carousel") !== undefined)
							{
								// console.log('owls_a: ._current');
								// console.log($("#slip_pict_area .owl-carousel").data("owl.carousel")._current);
								// console.log('owls_a: ._hash');
								// console.log($(element).find(".owl-item.center .item").attr('data-hash'));
							}
							// console.log('owls_a $(element).find(".owl-item.center .item")');
							// console.log($(element).find(".owl-item.center .item").attr('data-hash'));
							// console.log($(element).find(".owl-item.center .item"));
							// console.log('owls_a element: '+element);
							// console.log(element);
							// console.log('owls_a name: '+name);
							// console.log(name);
							// console.log('owls_a namespace: '+namespace);
							// console.log(namespace);
							// console.log('owls_a items: '+items);
							// console.log(items);
							// console.log('owls_a item: '+item);
							// console.log(item);
							// console.log('owls_a pages: '+pages);
							// console.log(pages);
							// console.log('owls_a page: '+page);
							// console.log(page);
							// console.log('owls_a size: '+size);
							// console.log(size);



							//--
							var slug =
							$(element).find(".owl-item .item").each(function(sort, item){
								//--
								var item = $(this);
								//--
								var slug = item.attr('data-slug');
								//--
								item.removeClass('tint-back--'+slug);

							});




							setTimeout(function(){
								//--
								var curr = $(element).find(".owl-item.center .item").attr('data-slug');
								//--
								if(owls_a.data("owl.carousel") !== undefined){
									// console.log('center: '+curr);
									// owls_b.data("owl.carousel").to(curr-1);

									//--
									console.log('owls_a: ._current');
									console.log(''+curr);
									console.log('owls_a: ._current');
									console.log($("#slip_pict_area .owl-carousel").data("owl.carousel")._current);
									console.log('owls_a: ._hash');
									console.log($(element).find(".owl-item.center .item").attr('data-hash'));

									//--
									var slug = $('#slip_pict_area .owl-carousel .owl-item .item[data-slug="'+curr+'"]').attr('data-slug');
									var mtag = $('#slip_pict_area .owl-carousel .owl-item .item[data-slug="'+curr+'"]').attr('data-mtag');
									var path_mtag = $('#slip_pict_area .owl-carousel .owl-item .item[data-slug="'+curr+'"] a').attr('data-path_mtag');
									$('#slip_pict_area .owl-carousel .owl-item .item[data-slug="'+curr+'"]').addClass('tint-back--'+slug);


									//--
									var shoot;
									var data_in;
									shoot = $('#col_rows #more');
									data_in = shoot.attr('data-in');

									//-- Mtag Back
									var path_mtag_back = shoot.attr('data-path_mtag_back');

									//--
									console.log("curr"+"->"+curr);
									console.log("path_mtag"+"->"+path_mtag);
									console.log("path_mtag_back"+"->"+path_mtag_back);

									console.log("path_mtag == path_mtag_back: "+(path_mtag == path_mtag_back));

									//--
									if( (path_mtag != '') && (path_mtag_back != '') ){
										//--
										if(path_mtag == path_mtag_back){
											console.log("path_mtag == path_mtag_back: "+(path_mtag == path_mtag_back));
											return false;
										}
										else{
											data_in = 0;
										}
									}

									//-- Filter Topic
									// shoot.attr('data-topic', mtag);


									//-- Mtag Update More
									if(path_mtag!='')
									{
										shoot.attr('data-path_mtag', path_mtag);
									}

									//--
									if(data_in != '-1'){
										//--
										$('#list_data').empty();

										//-- Page Number
										shoot.attr('data-in', '1');
										//-- Page Number
										shoot.attr('data-page', 0);

										//--
										$('#col_rows #more').click();
									}
									else
									{
										//-- Page Number
										shoot.attr('data-in', '0');
									}




								}

							}, 200);
						}
						,
						// , loop: true_false
						items: 12,
						loop: true,
						// touchDrag: true_false,
						// mouseDrag: true_false,
						mouseDrag: false,
						center: true,
						autoplay: false,
						autoWidth: false,
						// nav: true_false,
						nav: false,
						rewind: false,
						// dots: true_false,
						dots: false,
						dotData: false,
						lazyLoad: true,
						callbacks: true,
						autoplayHoverPause: true,
						animateIn: 'fadeIn',
						animateOut: 'fadeOut',
						responsiveRefreshRate: 50,
						singleItem: false,
						startPosition: posi,
						// afterInit: afterOWLSingle_Init,
						// responsive: true,
						// responsiveClass: true,
						navText: true_false ? ["<i class='tint-back--dark pict pict-keyboard_arrow_left relative circ--ss_p50x'></i>", "<i class='tint-back--dark pict pict-keyboard_arrow_right relative circ--ss_p50x'></i>"] : ["", ""]
						,
						responsive:{
							0:
							{
								  items: 3
								, dots: false
								, center: true
								, mouseDrag: true
								, touchDrag: true_false
								, nav: false
								, loop: true
								, singleItem: true
								, autoplay: false
							}
							, 686:
							{
								  items: 4
								// , dots: false
								// , nav: true
								// , autoplay: false
							}
							, 768:
							{
								  items: 7
								// , dots: false
								// , nav: true
								// , autoplay: false
							}
							, 991:
							{
								  items: 6
								, loop: true
								// , dots: false
								// , nav: true_false
								// , autoplay: true
							}
							, 1200:
							{
								  items: 11
								, dots: false
								, center: true
								, mouseDrag: true
								, touchDrag: true_false
								, nav: false
								, loop: true
								, singleItem: true
								, autoplay: false
							}
						}
					});

					// //--
					// owls_a.on('changed.owl.carousel', function(event) {
					// 	console.log('changed');
					// 	// el.find(".owl-item").eq(0).addClass("synced");
					// 	//-- Provided by the core
					// 	var element   = event.target;         // DOM element, in this example .owl-carousel
					// 	var name      = event.type;           // Name of the event, in this example dragged
					// 	var namespace = event.namespace;      // Namespace of the event, in this example owl.carousel
					// 	var items     = event.item.count;     // Number of items
					// 	var item      = event.item.index;     // Position of the current item
					// 	//-- Provided by the navigation plugin
					// 	var pages     = event.page.count;     // Number of pages
					// 	var page      = event.page.index;     // Position of the current page
					// 	var size      = event.page.size;      // Number of items per page

					// 	//--
					// 	console.log('event.item.index: '+event.item.index);
					// })
				}
			}

			// //-- 
			// $('.slider-for')
			// .on('init', function(){
			// 	//-- 
			// })
			// .slick({
			// 	nextArrow: '<a href="#" data-role="none" style="z-index: 2;" class="folk_content typo_content block line--ss_s1x --full --same push line move live laid--ss_r_s2x tint-back--wipe tint-text--dark slick-next" aria-label="Next" tabindex="0"><div class="full-width text-overflow no-underline block-inline full-width align-top __content rule--ss_c pict pict-keyboard_arrow_right"></div></a>',
			// 	prevArrow: '<a href="#" data-role="none" style="z-index: 2;" class="folk_content typo_content block line--ss_s1x --full --same push line move live laid--ss_l_s2x tint-back--wipe tint-text--dark slick-prev" aria-label="Prev" tabindex="0"><div class="full-width text-overflow no-underline block-inline full-width align-top __content rule--ss_c pict pict-keyboard_arrow_left"></div></a>',
			// 	fade: true, 
			// 	speed: 0, 
			// 	arrows: true, 
			// 	asNavFor: '.slider-nav', 
			// 	slidesToShow: 1, 
			// 	slidesToScroll: 1, 
			// 	initialSlide: posi 
			// });

			// //-- 
			// $('.slider-nav')
			// .on('init', function(even, data){
			// 	// console.log(even);
			// 	// console.log(data);
			// 	// console.log('lel -nav');
			// 	//-- 
			// 	//-- 
			// 	setTimeout(function () {
			// 		console.log($('.slider-nav'));
			// 		// var jobj = $('.slider-nav');
			// 		var jobj = data;
			// 			jobj.slickGoTo(posi);
			// 	}, 10);
			// });
			// //-- 
			// $('.slider-nav')
			// .slick({
			// 	// dots: true, 
			// 	// infinite: true, 
			// 	// speed: 200, 
			// 	// slidesToShow: 1, 
			// 	// centerMode: true, 
			// 	// variableWidth: true, 

			// 	dots: false, 
			// 	infinite: true, 
			// 	speed: 200, 
			// 	slidesToShow: 11, 
			// 	centerMode: true, 
			// 	variableWidth: false, 
			// 	cssEase: 'linear', 
			// 	// arrows: true, 
			// 	// fade: false, 
			// 	// asNavFor: '.slider-for', 
			// 	focusOnSelect: false, 
			// 	slidesToScroll: 1, 
			// 	centerPadding: '0px', 
			// 	// adaptiveHeight: false, 
			// 	// initialSlide: posi, 
			// 	// slide: 'a', 

			// 	responsive: 
			// 	[
			// 	// 	{
			// 	// 		breakpoint: 1200, 
			// 	// 		settings: 
			// 	// 		{
			// 	// 			arrows: false, 
			// 	// 			infinite: true, 
			// 	// 			centerMode: true, 
			// 	// 			slidesToShow: 3, 
			// 	// 			// slidesToScroll: 1, 
			// 	// 			centerPadding: '20px'
			// 	// 		}
			// 	// 	},
			// 	// 	{
			// 	// 		breakpoint: 992,
			// 	// 		settings: 
			// 	// 		{
			// 	// 			arrows: true, 
			// 	// 			infinite: true, 
			// 	// 			centerMode: true, 
			// 	// 			slidesToShow: 7, 
			// 	// 			slidesToScroll: 1, 
			// 	// 			centerPadding: '25px'
			// 	// 		}
			// 	// 	},
			// 	// 	{
			// 	// 		breakpoint: 768,
			// 	// 		settings: 
			// 	// 		{
			// 	// 			arrows: true, 
			// 	// 			infinite: true, 
			// 	// 			centerMode: true, 
			// 	// 			slidesToShow: 5, 
			// 	// 			slidesToScroll: 1, 
			// 	// 			centerPadding: '30px'
			// 	// 		}
			// 	// 	},
			// 		{
			// 			breakpoint: 468,
			// 			settings: 
			// 			{

			// 				arrows: false, 
			// 				infinite: true, 
			// 				centerMode: true, 
			// 				touchMove: true, 
			// 				slidesToShow: 3, 
			// 				// slidesToScroll: 1, 
			// 				variableWidth: false, 
			// 				centerPadding: '60px' 
			// 			}
			// 		}
			// 	]
			// });

			// $('.slider-nav').on('beforeChange', function(evnt, core, curr_item, next_item){
			// 	// console.log('curr_item');
			// 	// console.log(curr_item);
			// 	//-- 
			// 	// console.log('next_item');
			// 	// console.log(next_item);




			// 	//-- 
			// 	var slug = $('.slider-nav .item').each(function(sort, item){
			// 		//-- 
			// 		var item = $(this);
			// 		//-- 
			// 		var slug = item.attr('data-slug');
			// 		//-- 
			// 		item.removeClass('tint-back--'+slug);

			// 		//-- 
			// 		// console.log('item: '+slug);
			// 	});

			// 	//-- 
			// 	var slug = $('.slider-nav .item[data-sort="'+next_item+'"]').attr('data-slug');
			// 	var mtag = $('.slider-nav .item[data-sort="'+next_item+'"]').attr('data-mtag');
			// 	$('.slider-nav .item[data-sort="'+next_item+'"]').addClass('tint-back--'+slug);



			// 	//-- 
			// 	var item;
			// 	var data_in;
			// 	item = $('#col_rows #more');
			// 	data_in = item.attr('data-in');


			// 	//-- Filter Topic
			// 	item.attr('data-topic', mtag);

			// 	//-- 
			// 	if(data_in != '-1'){
			// 		//--
			// 		$('#list_data').empty();

			// 		//-- Page Number
			// 		item.attr('data-in', '1');
			// 		//-- Page Number
			// 		item.attr('data-page', 0);

			// 		//--
			// 		$('#col_rows #more').click();
			// 	}
			// 	else
			// 	{
			// 		//-- Page Number
			// 		item.attr('data-in', '0');
			// 	}


			// });


		};

		return fun;

	}());
	return Pag;
});


